import { ApolloProvider } from '@apollo/client'
import { ReactChild } from 'react'
import { client } from '../apollo'

const ApolloProviderWrapper = ({ children }: { children: ReactChild }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloProviderWrapper
